import * as e from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/Headphones.es.js";
const o = e.forwardRef((a, r) => /* @__PURE__ */ e.createElement(s, { ref: r, ...a, weights: t }));
o.displayName = "HeadphonesIcon";
const p = o;
export {
  p as Headphones,
  o as HeadphonesIcon
};
